import React, { Component } from 'react';
import {Link} from 'react-router-dom';

const title = "Follow Tegal on Social Media";

let WidgetGroupContentList = [
    {
        gName: 'Instagram',
        gDesc:"Join our community on Instgaram",
        btnText: 'Follow',
        btnIcon:'icofont-instagram',
        btnLink:'https://www.instagram.com/tegalapp',
        gCount: '14k+'
    },
    {
        gName: 'Facebook',
        gDesc:"Join our community on Facebook",
        btnText: 'Follow',
        btnIcon:'icofont-facebook',
        btnLink:'https://www.instagram.com/tegalapp',
        gCount: '12k+'
    },
]

class WidgetGroupSection extends Component {
    render() {
        return (
            <div className="widget active-group">
                <div className="widget-inner">
                    <div className="widget-title">
                        <h5>{title}</h5>
                    </div>
                    <div className="widget-content">
                        {WidgetGroupContentList.map((val, i) => (
                            <div className="group-item lab-item" key={i}>
                                <div className="lab-inner d-flex flex-wrap align-items-center">
                                    <div className="lab-content w-100">
                                        <h6>{val.gName}</h6>
                                        <p>{val.gDesc}</p>
                                
                                        <div className="test"> <Link to={val.btnLink} className="lab-btn"><i className={val.btnLink}></i> {val.btnText}</Link></div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default WidgetGroupSection;